var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2955 10.3636H11.1364C10.4854 10.3636 9.86105 10.105 9.40074 9.64467C8.94042 9.18436 8.68182 8.56003 8.68182 7.90905V0.749956C8.68182 0.695707 8.66027 0.64368 8.62191 0.60532C8.58355 0.56696 8.53152 0.54541 8.47727 0.54541H3.77273C2.90475 0.54541 2.07231 0.890214 1.45856 1.50397C0.844804 2.11773 0.5 2.95016 0.5 3.81814V20.1818C0.5 21.0498 0.844804 21.8822 1.45856 22.4959C2.07231 23.1097 2.90475 23.4545 3.77273 23.4545H15.2273C16.0953 23.4545 16.9277 23.1097 17.5414 22.4959C18.1552 21.8822 18.5 21.0498 18.5 20.1818V10.5681C18.5 10.5139 18.4784 10.4619 18.4401 10.4235C18.4017 10.3851 18.3497 10.3636 18.2955 10.3636Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsIcon);
export default __webpack_public_path__ + "static/media/DocumentsIcon.6ca263555a1f261e0887d7a4dc5440a3.svg";
export { ForwardRef as ReactComponent };